import {
  SpecialtyDto,
  SpecialtyLabelVM,
  SpecialtyPayloadVM,
} from "../types/specialty.definition";
import {
  requestCreateSpecialties,
  requestDeleteSpecialty,
  requestGetSpecialtyById,
  requestGetSpecialties,
  requestUpdateSpecialty,
} from "../webclients/specialty.client";

export const specialtyApi = {
  getSpecialties: async (lang: string = "fr"): Promise<SpecialtyDto[]> => {
    const response = await requestGetSpecialties(lang);
    return response.data as SpecialtyDto[];
  },

  getSpecialtyById: async (
    id: number,
    lang: string = "fr"
  ): Promise<SpecialtyDto> => {
    const response = await requestGetSpecialtyById(id, lang);
    return response.data as SpecialtyDto;
  },

  getAllTranslations: async (id: number): Promise<SpecialtyLabelVM> => {
    const [enRes, frRes, arRes] = await Promise.all([
      requestGetSpecialtyById(id, "en"),
      requestGetSpecialtyById(id, "fr"),
      requestGetSpecialtyById(id, "ar"),
    ]);
    return {
      en: (enRes.data as SpecialtyDto).label ?? "",
      fr: (frRes.data as SpecialtyDto).label ?? "",
      ar: (arRes.data as SpecialtyDto).label ?? "",
    };
  },

  createSpecialties: async (
    data: SpecialtyPayloadVM[]
  ): Promise<SpecialtyDto[]> => {
    const response = await requestCreateSpecialties(data);
    return response.data as SpecialtyDto[];
  },

  updateSpecialty: async (
    id: number,
    data: SpecialtyPayloadVM
  ): Promise<SpecialtyPayloadVM> => {
    const response = await requestUpdateSpecialty(id, data);
    return response.data as SpecialtyPayloadVM;
  },

  deleteSpecialty: async (id: number): Promise<void> => {
    await requestDeleteSpecialty(id);
  },
};
